import React from 'react'
import EditProfile from "../../components-user/manage-company/Profile";

export default function Profile() {
  return (
    <EditProfile />
  )
}
